import { browserEnv } from '@/utils/common/platform'
// 获取页面标题状态
export const hasHeader = () => {
  const isWx = browserEnv.wx || browserEnv.Alipay
  return !isWx
}
